import React from 'react'
import SupportHeader from 'src/supportPortal/layout/SupportHeader'
import InvoiceListing from 'src/supportPortal/views/payoutReports/InvoiceListing'

export default function ClinicBrandInvoices() {
  return (
    <>
      <SupportHeader heading="Clinic Brand Invoices" />
      <InvoiceListing
        targetEntityType='clinic-brand'
        bookedEventsListingApiSignature='/api/secure/cc/support/invoices/payout-invoice/booked-events'
        initialFilters={{
          targetEntityTypes: 'clinic-brand ',
        }}
      />
    </>
  )
}
